import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class LayoutService {

  private heroItemSource = new BehaviorSubject<boolean>(false); // Observable hero Item source
  heroItem = this.heroItemSource.asObservable(); // Observable hero Item stream


  // service command
  changeHero(visibility: boolean) {
    this.heroItemSource.next(visibility);
    console.log('Visibility changed to ' + visibility);
  }

}



// WEBPACK FOOTER //
// ./client/app/core/layout/secure/layout.service.ts